import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { UserApi } from '../../app/api/user.api';


export function ForgotPasswordModal({ show, onHide }) {
  
  const user = UserApi();

  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(0);
    setIsLoading(true);
    try {
        const {data} = await user.genPasswordToken({email: email});
        setIsLoading(false);
        if( data.success ){
          setIsSubmitted(true);
        }
        else{
          setIsSubmitted(false);
          setStatus(-1);
        }
    } catch (err) { 
        setStatus(-1);
        setIsLoading(false);     
        const response = err?.response?.data;
      
        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].msg || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="text-green fs-5 px-3">
          <i className="bi bi-lock me-2"></i>
          Récupération de mot de passe
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        { !isSubmitted ? (
          <div>
            <p className="text-secondary mb-3 px-3">
              Entrez votre adresse email pour recevoir les instructions de réinitialisation.
            </p>
            <form onSubmit={handleSubmit} className='p-3'>
              <div className="d-flex justify-content-center">
                {
                  isLoading && (
                    <div className="d-flex justify-content-center mb-2"> 
                      <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }
                {
                  status === -1 && (
                    <div className="alert alert-danger small mb-3 w-100"> { message } </div>
                  )
                }
              </div>
              <div className="mb-3">
                <label className="small text-secondary mb-1 ps-2" htmlFor="forgot-email"> 
                    <i className="bi bi-envelope me-2"></i> Adresse email
                </label>
                <input name="email" type="email" className="input-field text-muted" placeholder="votre.email@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required id="forgot-email" />
              </div>
              <button type="submit" className="btn btn-green w-100">
                <i className="bi bi-send me-2"></i>
                Envoyer
              </button>
            </form>
          </div>
        ) : (
          <div className="text-center">
            <div className="mb-3">
              <i className="bi bi-check-circle text-success" style={{ fontSize: '3rem' }}></i>
            </div>
            <p className="text-secondary">
              Un email de récupération a été envoyé à <strong>{email}</strong>
            </p>
            <p className="text-muted small">
              Vérifiez votre boîte de réception et suivez les instructions pour réinitialiser votre mot de passe.
            </p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
